export default __webpack_public_path__ + "static/media/ps-analytics.80bfeab2.svg";